import React, { useEffect, useRef, useState } from 'react';

import { Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem } from 'reactstrap';
import styled from 'styled-components';
import city3 from '../../../../assets/utils/images/dropdown-header/city3.jpg';
import EVT_TYPE from '@util/staticData/eventType';
import { useAsync, useTranslation } from '@hooks';
import { fetchAlertInfo, fetchNumOfUnreadAlert } from '@api/alert';
import TimeLine from '@components/TimeLine';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const WrappedAlertBody = styled.div`
    margin-left: 1rem;
    height: 300px;
`;

const SeeMoreBtn = styled.button`
    width: 120px;
    height: 35px;
    color: white;
    background-color: #6e6c96;
    border-radius: 20px;
    outline: none;
    border: none;
    padding: 0.5rem;
`;

const getEvtType = evtTypeMap => {
    const evtTypes = [];
    for (let type in evtTypeMap) {
        evtTypes.push({
            type: type,
            name: evtTypeMap[type],
            typeClassName: '', // isDanger(type) ? 'text-danger' : 'text-primary',
        });
    }
    return evtTypes;
};

const COUNT_TIME = 20000;
const END_OF_LIST = -1;
const AlarmDots = () => {
    const t = useTranslation('Alert');
    const location = useLocation();
    const toggleRef = useRef();
    const [open, setOpen] = useState(false);
    const [alertList, setAlertList] = useState([]);
    const [lastKeyNum, setLastKeyNum] = useState();
    const [clickBtn, setClickBtn] = useState(false);
    const [showArrow, setShowArrow] = useState(false);

    const eventType = getEvtType(EVT_TYPE);

    const [count, setCount] = useState(0);
    const { promise: getNumOfUnreadAlert } = useAsync({
        promise: fetchNumOfUnreadAlert,
        keepState: true,
        resolve: res => {
            const { count } = res;
            setCount(count);
        },
        reject: error => console.error(error),
    });

    const { promise: getAlertList } = useAsync({
        promise: fetchAlertInfo,
        fixedParam: { isAlertCheckStatus: 'Y' },
        resolve: res => {
            if (clickBtn && res.rows.length > 0) {
                setShowArrow(true);
                setClickBtn(false);
            }
            setLastKeyNum(res.lastKeyNum);
            setAlertList(alertList.concat(makeAlertList(res.rows)));
        },
        reject: error => console.error(error),
    });

    const makeAlertList = alertList => {
        return alertList.reduce((acc, alert) => {
            let evtType = eventType.find(type => type.type === alert.interfaceCommandType);
            if (evtType) {
                let time = moment(alert.regDate * 1000).format('HH:mm');
                let hour = moment(alert.regDate * 1000).format('HH');
                hour >= 12 && hour <= 23 ? (time = `${time} PM`) : (time = `${time} AM`);

                acc.push({
                    level: 'warning',
                    type: evtType.name,
                    typeClassName: evtType.typeClassName,
                    dateStr: time,
                    targetName: alert.targetName,
                    location: alert.floorName,
                    targetNum: alert.targetNum,
                    interfaceCommandType: alert.interfaceCommandType,
                    latLng: [alert.lat, alert.lng],
                    floorId: alert.floorId,
                });
            }
            return acc;
        }, []);
    };

    const handleClick = e => {
        e.stopPropagation();
        getAlertList({
            firstKeyNum: lastKeyNum,
        });
        setClickBtn(true);
    };

    const handleScrollEvent = event => {
        if (event) {
            setShowArrow(false);
        }
    };

    const click = e => {
        const target = e.currentTarget;
        const toggleButton = toggleRef.current;
        if (target === toggleButton) {
            setAlertList([]);
            getNumOfUnreadAlert();
            if (!open) {
                getAlertList();
            }
            setOpen(!open);
        }
    };

    const countIntvRef = useRef();
    const clearCountIntv = () => {
        clearInterval(countIntvRef.current);
        countIntvRef.current = null;
    };

    useEffect(() => {
        if (countIntvRef.current) {
            clearCountIntv();
        }
        getNumOfUnreadAlert();
        countIntvRef.current = setInterval(() => {
            getNumOfUnreadAlert();
        }, COUNT_TIME);
        return () => {
            clearCountIntv();
        };
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location]);

    return (
        <div className="header-dots alarm-box">
            <Dropdown isOpen={open} toggle={click}>
                <DropdownToggle
                    innerRef={toggleRef}
                    className="pnt-btn btn-icon-only btn-trans d-flex border-0 overflow-visible text-decoration-none"
                    color="link"
                >
                    <span className="material-icons-round">notifications</span>
                    {!!count && <div className="alarm-num">{count > 999 ? '999+' : count}</div>}
                </DropdownToggle>
                <DropdownMenu right className="dropdown-menu-xl rm-pointers bg-depth-base">
                    <div className="dropdown-menu-header mb-0">
                        <div className="dropdown-menu-header-inner" style={{ backgroundColor: '#453e6f' }}>
                            {/*<div className="menu-header-image opacity-1" style={{ backgroundImage: `url(${city3})` }} />*/}
                            <div className="menu-header-content ">
                                <h5 className="menu-header-title text-white">{t('Alerts')}</h5>
                            </div>
                        </div>
                    </div>
                    <WrappedAlertBody onScroll={handleScrollEvent}>
                        <TimeLine events={alertList} />
                        {showArrow && (
                            <span
                                className="material-icons-round"
                                style={{
                                    position: 'absolute',
                                    right: 20,
                                    bottom: 80,
                                    color: '#bdbebf',
                                    fontWeight: 'bold',
                                    fontSize: '1.2rem',
                                }}
                            >
                                arrow_downward
                            </span>
                        )}
                    </WrappedAlertBody>
                    {lastKeyNum !== END_OF_LIST && (
                        <Nav vertical>
                            <NavItem className="nav-item-divider" />
                            <NavItem className="nav-item-btn text-center">
                                <SeeMoreBtn
                                    className="btn-shadow btn-wide btn-pill"
                                    color="focus"
                                    onClick={handleClick}
                                >
                                    {t('See more')}
                                </SeeMoreBtn>
                            </NavItem>
                        </Nav>
                    )}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

export default AlarmDots;
